<template>
    <div class="login">
        <h3>Sign In</h3>
        <md-field><label>EMail:</label><md-input type="text" v-model="email" placeholder="Email"/></md-field>
        <md-field><label>Password:</label><md-input type="password" v-model="password" placeholder="Password"/></md-field>
        <md-button v-on:click="signIn">Connection</md-button>
        <p>You don't have an account ? You can <router-link to="/sign-up">create one</router-link></p>
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'login',
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signIn: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        (user) => {
          this.$router.replace('hello')
        },
        (err) => {
          alert('Oops. ' + err.message)
        }
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue